module.exports = __webpack_public_path__ + "static/media/user.f18658c2.svg";